import { createBrowserRouter } from "react-router-dom";
import { fallbackRoutes } from "./fallbackRoutes";
import { homeRoutes } from "./homeRoutes";
import { operationalRoutes } from "./operationalRoutes";
import { authRoutes } from "./authRoutes";
import { RouteErrorBoundary } from "../shared/pages/RouteErrorBoundary";

export const router = createBrowserRouter([
    ...authRoutes,
    ...fallbackRoutes,
    ...homeRoutes,
    ...operationalRoutes,
].map(route => ({
    ...route,
    errorElement: <RouteErrorBoundary />,
})));